// Version : 1.0.0
// Author : AGALYA

const PersonalDetailsActionType = {
	/** ***************** Personal Details Add Start ************************/
	PERSONAL_DETAILS_START: 'personal-details_start',
	PERSONAL_DETAILS_SUCCESS: 'personal-details_success',
	PERSONAL_DETAILS_FAILURE: 'personal-details_failure',
	PERSONAL_DETAILS_RESPONSE_REST_START: 'personal-details_response_reset_start',
	PERSONAL_DETAILS_RESPONSE_CHANGED: 'personal-details_response_changed',
	/** ***************** Personal Details Add End ************************/
};

export default PersonalDetailsActionType;
